<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [width]="width"
  [data]="data"
  [title]="data.headline"
  [footer]="footer">
  <ng-template #content>
    <div class="flex w-full flex-col">
      <span class="text-standard-text-primary text-xl">
        {{ data.ticketCategory.name }}
      </span>
      <span class="text-standard-text-secondary">
        {{ cmsTextProvider.ticketCategories.pickTicketsByMultiSelect }}
      </span>
    </div>
    <div class="mt-5 flex flex-col">
      <div class="flex w-full flex-col gap-5">
        <div
          class="border-standard-outline-light flex flex-row items-center justify-between rounded-lg border-1 p-2">
          <span class="material-symbols-rounded">search</span>
          <input
            class="text-standard-text-secondary w-full border-0 outline-none focus:ring-0"
            placeholder="Suche"
            [attr.data-testid]="'search-' | appendTestId: 'input'"
            [id]="'search-tickets'"
            [formControl]="searchControl" />
        </div>
        <div
          class="border-standard-outline-light flex w-full flex-col rounded-lg border-1">
          <div
            class="bg-standard-surface flex min-h-20 w-full items-center justify-start rounded-lg p-2 font-semibold"
            tabindex="0"
            id="ticket-drag-and-drop-list-header"
            [attr.data-testid]="'ticket-drag-and-drop-list-header'">
            <aw-checkbox
              id="id"
              class="flex max-w-10"
              [formControl]="allChecked"></aw-checkbox>
            {{ cmsTextProvider.ticketCategories.designation }}
            <span
              (click)="toggleSort()"
              class="material-symbols-rounded cursor-pointer pl-1 text-inherit">
              {{
                sortState === SortOrder.ASC
                  ? 'arrow_downward_alt'
                  : sortState === SortOrder.DESC
                    ? 'arrow_upward_alt'
                    : 'height'
              }}
            </span>
          </div>
          @if (visibleTickets.length === 0) {
            <div class="flex min-h-20 w-full items-center justify-center">
              {{ cmsTextProvider.ticketCategories.noTicketsFound }}
            </div>
          } @else {
            <div class="max-h-180 max-w-screen overflow-y-auto">
              @for (ticket of visibleTickets; track $index) {
                <div
                  class="border-standard-outline-light flex min-h-20 w-full items-center justify-start border-t-1 p-2">
                  <aw-checkbox
                    id="id"
                    class="flex max-w-10"
                    [formControl]="
                      ticketSelectionForm.controls[
                        getTicketSelectionKey(ticket)
                      ]
                    "></aw-checkbox>
                  <div [attr.data-testid]="'ticket-' + $index">
                    {{ ticket.name }}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full flex-row justify-end gap-2">
      <aw-button
        [id]="'discard-changes'"
        [style]="'primary-alt'"
        [type]="'button'"
        [text]="cmsTextProvider.shared.cancel"
        (click)="dialogRef.close()">
      </aw-button>
      <aw-button
        [id]="'add-new-category'"
        [style]="'primary'"
        [type]="'button'"
        [text]="cmsTextProvider.shared.save"
        (click)="save()">
      </aw-button>
    </div>
  </ng-template>
</aw-dialog>
